import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';

//#region INTERFACE IFeatureBarcodeScanner
export interface IFeatureBarcodeScanner extends IUserAccessFeature, Object {
}

//#endregion

//#region CONST _FEATURE_BARCODE_SCANNER_DEFAULT
export const _FEATURE_BARCODE_SCANNER_DEFAULT: Readonly<IFeatureBarcodeScanner & Object> = {
  displayText: NavigationPageEnumHumanReadable.BarcodeScannerPage,
  feature: NavigationPageEnum.BarcodeScannerPageHome,
  ref: SettingsReferenceEnum.undefined,
  standalone: false,
};
//#endregion
